import WhatWeDo from './WhatWeDO';
import AboutFounder from './AboutFounder';
// import CoInstructor from './CoInstructors';
import OurAward from './Award';
import NeedAdvice from './Advice';
import VisionStatement from './Vision&Mission/VisionStatement';
import MissionStatement from './Vision&Mission/MissionStatement';
import Feedback from './Feedback';
import CoursesLdDisplay from './FeaturedCourses/CoursesLdDisplay';
import Footer from '../../components/shared/Footer';
// import BecomeAffliate from './BecomeAffiliate';
import LandingNav from '../../components/shared/LandingNav';
import Faq from './Faqs/Faq';


const Landing = () => {
  return (
    <div>
      <LandingNav />
      <WhatWeDo />
      <AboutFounder />
      {/* <CoInstructor /> */}
      <OurAward />
      {/* <BecomeAffliate /> */}
      <NeedAdvice />
      <CoursesLdDisplay />
      <Feedback />
      <VisionStatement />
      <MissionStatement />
      <NeedAdvice/>
      <Faq/>
      <Footer />

    </div>
  );
}

export default Landing
